/* eslint-disable sort-keys */

const fonts = {
  family: {
    default: 'OpenSans, sans-serif',
  },
  weight: {
    light: '300',
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800',
  },
};

export default fonts;
